exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-title[data-v-c2a109be]{color:var(--titleTextColor);background-color:var(--collapseHeadHeaderBg);border-color:var(--collapseBorder)}.red-border[data-v-c2a109be] .el-input__inner{border-color:red!important}", ""]);

// exports
